import React from 'react';
import { useNavigate } from 'react-router-dom';

import Image from '../../../components/AppImage';

const RecentMessage = ({ message }) => {
  const navigate = useNavigate();

  const formatTime = (date) => {
    const now = new Date();
    const messageDate = new Date(date);
    const diffInMinutes = Math.floor((now - messageDate) / (1000 * 60));

    if (diffInMinutes < 60) {
      return `${diffInMinutes} dakika önce`;
    } else if (diffInMinutes < 1440) {
      return `${Math.floor(diffInMinutes / 60)} saat önce`;
    } else {
      return `${Math.floor(diffInMinutes / 1440)} gün önce`;
    }
  };

  return (
    <button
      onClick={() => navigate(`/campaign-management?id=${message?.campaignId}&tab=messages`)}
      className="w-full flex items-start gap-3 p-3 hover:bg-muted rounded-lg transition-smooth text-left"
    >
      <div className="relative">
        <Image
          src={message?.avatar}
          alt={message?.avatarAlt}
          className="w-10 h-10 rounded-full object-cover"
        />
        {message?.unread && (
          <div className="absolute -top-1 -right-1 w-3 h-3 bg-primary rounded-full border-2 border-card" />
        )}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between mb-1">
          <h4 className="text-sm font-semibold text-foreground truncate">
            {message?.sender}
          </h4>
          <span className="text-xs text-muted-foreground flex-shrink-0 ml-2">
            {formatTime(message?.timestamp)}
          </span>
        </div>
        <p className={`text-sm truncate ${message?.unread ? 'text-foreground font-medium' : 'text-muted-foreground'}`}>
          {message?.content}
        </p>
      </div>
    </button>
  );
};

export default RecentMessage;